import React from 'react';

const EditDesign = () => (
  <svg viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd">
      <path fill="#5EB530" d="M7.91 7.817l7.911 7.817V7.817z"/>
      <path fill="#AFCF29" d="M7.91 15.634h7.911l-7.91-7.817z"/>
      <path fill="#E51312" d="M0 0v7.817h7.91L0 0z"/>
      <path fill="#8B4998" d="M0 0l7.91 7.817V0z"/>
      <path fill="#14ACE4" d="M7.91 0v7.817L15.822 0z"/>
      <path fill="#51B786" d="M15.821 0l-7.91 7.817h7.91z"/>
      <path fill="#E1DB0D" d="M0 15.634h7.91V7.817z"/>
      <path fill="#E19813" d="M0 7.817v7.817l7.91-7.817z"/>
    </g>
  </svg>
);

export default EditDesign;
